export function TopBar() {
  return (
    <div className="bg-[--ui-green] text-[#000] py-6 px-8 flex justify-between items-center z-10">
      <img
        src="https://d1mdu1cxiv2wrk.cloudfront.net/nyc/images/experience abu dhabi logo.svg"
        alt="Experience with Abu Dhabi"
        className="h-[26px] md:h-[46px]"
        color="black"
      />
      <img
        src="https://d1mdu1cxiv2wrk.cloudfront.net/nyc/images/powered by.svg"
        alt="Tripadvisor Logo"
        className="h-[15px] md:h-[20px] w-auto"
      />
    </div>
  );
}
